<template>
  <BOverlay :show="isLoading">
    <BRow v-if="localPercentDetails">
      <BCol cols="12">
        <h5>
          گروه‌بندی
          <span class="font-weight-bolder">
            {{ customPercentDetails.title }}
          </span>
        </h5>
        <hr class="mb-2" />
      </BCol>

      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          :inputId="`masterBasePricePercent${localPercentDetails.priceCateogryId}`"
          inputLabel="مبلغ درآمد استاد"
          inputPlaceholder="30"
          v-model="localPercentDetails.masterPrice"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>

      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          :inputId="`userBasePricePercent${localPercentDetails.priceCateogryId}`"
          inputLabel="مبلغ پرداختی زبان آموز"
          inputPlaceholder="30"
          v-model="localPercentDetails.masterUserPrice"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>

      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton
          @click="updateMasterCustomPercentForPriceCategory"
          variant="success"
          size="sm"
        >
          ویرایش
        </BButton>
      </BCol>
    </BRow>
  </BOverlay>
</template>

<script>
export default {
  emits: ["refetch", "getPriceCategoryDetails"],
  props: {
    customPercentDetails: {
      type: Object,
      required: true,
    },
  },
  watch: {
    customPercentDetails: {
      handler(val) {
        if (val) {
          this.localPercentDetails = JSON.parse(
            JSON.stringify(this.customPercentDetails)
          );

          this.$emit("getPriceCategoryDetails", {
            userId: this.localPercentDetails.userId,
            priceCategoryId: this.localPercentDetails.priceCateogryId,
            masterPrice:
              this.localPercentDetails.masterPrice,
            masterUserPrice:
              this.localPercentDetails.masterUserPrice,
          });
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      localPercentDetails: null,
      isLoading: false,
    };
  },
  methods: {
    generatePriceCategoryPercentPayload() {
      return {
        userId: this.localPercentDetails.userId,
        priceCategoryId: this.localPercentDetails.priceCateogryId,
        masterPercent: this.localPercentDetails.masterPrice,
        masterUserPercent: this.localPercentDetails.masterUserPrice,
      };
    },
    async updateMasterCustomPercentForPriceCategory() {
      const newPayload = this.generatePriceCategoryPercentPayload();
      try {
        this.isLoading = true;
        const _this = this;
        const updateMasterPriceCategoryCustomPercents =
          new UpdateMasterPriceCategoryCustomPercents(_this);

        updateMasterPriceCategoryCustomPercents.setRequestParam(newPayload);
        await updateMasterPriceCategoryCustomPercents.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
                text: `درصد شخصی سازی شده استاد در گروه‌بندی ${this.localPercentDetails.title} با موفقیت ویرایش شد.`,
              },
            });
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomAppendText,
    BRow,
    BCol,
    BButton,
    BOverlay,
  },
};
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BRow, BCol, BButton, BOverlay } from "bootstrap-vue";
import { UpdateMasterPriceCategoryCustomPercents } from "@/libs/Api/Users";
</script>
